import { Button } from '@/components/ui/button'
import { Calendar, type CalendarProps } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { T } from '@tolgee/react'
import dayjs from 'dayjs'
import { CalendarDaysIcon } from 'lucide-react'
import { useState } from 'react'

type DatePickerProps = Readonly<{
  date?: Date
  title: string
  calendarProps?: CalendarProps & {
    onDayClick?: (date: Date, modifiers: any, e: any) => void
  }
  disabled?: boolean
}>

export const DatePicker = ({ date, title, calendarProps = {}, disabled }: DatePickerProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          unstyled
          title={title}
          disabled={disabled}
          className='relative flex h-8 w-[164px] select-none items-center gap-2 whitespace-nowrap rounded border border-neutral-75 bg-neutral-white px-2 text-sm font-light text-neutral-500 shadow-none hover:bg-neutral-50 focus:outline-0 active:bg-neutral-50 disabled:bg-neutral-50'
        >
          <CalendarDaysIcon className='size-5 text-neutral-150' />
          {date ? (
            dayjs(date).format('MM/DD/YYYY')
          ) : (
            <T keyName='history.filters.datePicker.label' />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0'>
        <Calendar
          {...calendarProps}
          onDayClick={(date, modifiers, e) => {
            calendarProps.onDayClick?.(date, modifiers, e)
            setOpen(false)
          }}
          showYearSwitcher={false}
        />
      </PopoverContent>
    </Popover>
  )
}
